import React from "react";

const HassleFreeInstallation = () => {
  return (
    <div className="bg-[#fff] w-full flex flex-col">
      <div
        className="relative w-full bg-cover bg-center h-[550px] flex items-center justify-center"
        style={{
          backgroundImage: "url('/images/wheel-alignment.png')",
        }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative text-center px-6 md:px-12 lg:px-20 max-w-4xl">
          <h1 className="text-white text-3xl md:text-5xl font-bold leading-tight mb-4">
            How Express Tire Works Ensures Hassle-Free Installations
          </h1>
          <p className="text-gray-200 text-lg md:text-xl">
            From ordering to installation — we’ve made every step smooth,
            transparent, and stress-free for our customers.
          </p>
        </div>
      </div>

      <section className="w-full px-4 py-10 md:px-12 lg:px-24 xl:px-32">
        <div className="mx-auto max-w-4xl text-gray-800 leading-relaxed">
          <p className="mb-6">
            At <strong>Express Tire Works</strong>, our goal is simple — offer the
            easiest, fastest, and most reliable tire installation service.
            Whether you order online or visit our store, we ensure your experience
            is smooth from start to finish. Here’s how we make installations truly
            hassle-free.
          </p>

          <div className="mt-8">
            <h2 className="text-black text-2xl font-semibold mb-3 pl-4 border-l-4 border-yellow-500">
              1. Easy Online Ordering With Transparent Pricing
            </h2>
            <p>
              Our website allows you to browse top tire and wheel brands with clear,
              upfront pricing. No hidden fees and no confusing add-ons — you get the
              right price instantly.
            </p>
            <ul className="list-disc pl-6 mt-2 mb-4">
              <li>Compare brands and models easily</li>
              <li>Real-time inventory visibility</li>
              <li>Detailed sizing and fitment information</li>
            </ul>
            <p>
              Transparency is at the heart of our service. You always know what you're buying
              and how much you'll pay.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-black text-2xl font-semibold mb-3 pl-4 border-l-4 border-yellow-500">
              2. Convenient Appointment Booking
            </h2>
            <p>
              Once you select your tires or wheels, you can instantly book an appointment
              that fits your schedule. We value your time, which is why we ensure minimal
              waiting and maximum convenience.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-black text-2xl font-semibold mb-3 pl-4 border-l-4 border-yellow-500">
              3. Professional Installation by Trained Technicians
            </h2>
            <p>
              Our in-house experts follow strict installation standards using modern equipment
              to ensure safety and accuracy. Every installation includes:
            </p>
            <ul className="list-disc pl-6 mt-2 mb-4">
              <li>Precision wheel mounting and balancing</li>
              <li>Air pressure checks for optimal performance</li>
              <li>Inspection for leaks, damage, or alignment issues</li>
              <li>Fast and careful handling of your vehicle</li>
            </ul>
            <p>
              Your vehicle is treated with the highest level of care — no shortcuts, no rush jobs.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-black text-2xl font-semibold mb-3 pl-4 border-l-4 border-yellow-500">
              4. In-House Inventory for Same-Day Service
            </h2>
            <p>
              We keep popular tire and wheel brands stocked in our warehouse, making same-day
              or next-day installation possible for most customers.
            </p>

            <ul className="list-disc pl-6 mt-2 mb-4">
              <li>No long waits for deliveries</li>
              <li>Instant replacements for damaged or incompatible items</li>
              <li>Quick turnaround for urgent needs</li>
            </ul>

            <p>
              Our stocked inventory ensures you're never left waiting unnecessarily.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-black text-2xl font-semibold mb-3 pl-4 border-l-4 border-yellow-500">
              5. Clear Communication From Start to Finish
            </h2>
            <p>
              We make sure you’re informed at every step — from order confirmation to
              installation completion. If there’s ever a question, our team is always ready
              to help.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-black text-2xl font-semibold mb-3 pl-4 border-l-4 border-yellow-500">
              6. A Process Designed for Customer Comfort
            </h2>
            <p>
              Our service is engineered to reduce stress, confusion, and waiting time.
              Every detail — from booking to installation — is built around customer comfort
              and convenience.
            </p>

            <ul className="list-disc pl-6 mt-2 mb-4">
              <li>Fast service with minimal waiting</li>
              <li>Comfortable waiting areas</li>
              <li>Friendly and knowledgeable staff</li>
              <li>Accurate service estimates</li>
            </ul>
          </div>

          <div className="mt-8">
            <h2 className="text-black text-2xl font-semibold mb-3 pl-4 border-l-4 border-yellow-500">
              7. Guaranteed Satisfaction
            </h2>
            <p>
              All installations at Express Tire Works meet industry standards. If anything
              feels off after service, we offer free post-installation checks for peace of mind.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-black text-2xl font-semibold mb-3 pl-4 border-l-4 border-yellow-500">
              Final Thoughts
            </h2>
            <p>
              At <strong>Express Tire Works</strong>, we take pride in delivering a stress-free,
              premium-quality installation experience. From online ordering to precise installation,
              everything is built to make your life easier. When you choose Express Tire Works,
              you choose convenience, transparency, and exceptional customer service.
            </p>
          </div>
        </div>
      </section>

      <section className="mb-12">
        <div className="max-w-4xl mx-auto flex flex-wrap justify-center gap-3">
          <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Tire Installation</p>
          <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Express Tire Works</p>
          <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Car Service</p>
          <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Wheel Fitting</p>
          <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Hassle-Free Service</p>
        </div>
      </section>
    </div>
  );
};

export default HassleFreeInstallation;
